import { useQuery } from '@tanstack/react-query';

import { ottFetchStatsFetcher } from '../../fetchers/ott-fetcher';

type Props = {
  data: any;
  isLoading: boolean;
  refetch: () => void;
  isFetched: boolean;
};

const useOttFetchStats = ({ typeId, userId }: { typeId: string; userId: string }): Props => {
  const { data, isLoading, refetch, isFetched } = useQuery(
    [
      'ott-fetch-stats',
      {
        userId,
        typeId,
      },
    ],
    ottFetchStatsFetcher,
    {
      enabled: !!typeId && !!userId,
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 60 * 10 * 1000,
    },
  );

  return {
    isLoading,
    data: data?.data || [],
    refetch,
    isFetched,
  };
};

export default useOttFetchStats;
